import script from "./CommonInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommonInput.vue?vue&type=script&setup=true&lang=ts"

import "./CommonInput.vue?vue&type=style&index=0&id=f2f5eb98&lang=sass"

const __exports__ = script;

export default __exports__